import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "update-question",
  initialState: initialState,
  reducers: {
    initUpdateQuestion: () => {
      return { ...initialState };
    },
    startUpdateQuestion: (state) => {
      state.loading = true;
    },
    successUpdateQuestion: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorUpdateQuestion: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initUpdateQuestion,
  startUpdateQuestion,
  successUpdateQuestion,
  errorUpdateQuestion,
} = dataSlice.actions;

export default dataSlice.reducer;
